<template>
    <!-- 功能列表 -->
    <div class="scrollTopFix">


        <!-- 占位div -->
        <div id="btnSetLocation" class="boxSize listSpacing">
        </div>

        <a :href='loginUrl'>
            <div id="btn2" class="boxSize listSpacing">
                <div class="circle100 financing"></div>
                <div id="RongZi" ><p>我要融资</p></div>
            </div>
        </a>

        <!-- 占位div -->
        <div id="btnSetLocation" class="boxSize listSpacing">
        </div>
        
        <a :href='loginUrl'>
            <div id="btn3" class="boxSize listSpacing">
                <div class="circle100 discount"></div>
                <div id="TouZi"> <p>我要投资</p> </div>
            </div>
        </a>

        <!-- 占位div -->
        <div id="btnSetLocation" class="boxSize listSpacing">
        </div>


    </div>
</template>

<script>
    import config from '../../../config/ipConfig'
    export default{
        name: "FunctionButtons",
        data(){
            return {
                loginUrl: config.loginUrl,
            }
        },
    }
    
</script>

<style scoped>

a{
    /* height: 100px;
    width: 100px;
    display: block; */
    color: #000;
    /* float:left; */
}

a:hover .circle100{
    background-color: #bfbfbf;
    color: skyblue;
}

.circle100{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    
    /* margin-top: -10px; */
    
}
#RongZi{
    width: 100%;
    height: 100%;
    padding-left: 15%;
    font-weight:bold
}
#TouZi{
    width: 100%;
    height: 100%;
    padding-left: 15%;
    font-weight:bold
}
/* 控融资投资的大小 */
.scrollTopFix{
    width: 1920px;
    height: 189px;
    background-color: #fff;
    position: sticky;
    top: 0px;
    /* padding: 10px 0 20px 450px; */

    padding-left: 10%;  /* 内部内容偏移10% 为了居中对齐 */
    z-index: 10;
    display: flex; /*设为 Flex 布局以后，子元素的float、clear和vertical-align属性将失效*/
	display: -webkit-flex; /* Safari */
	flex-direction: row-reverse;/*容器内项目的排列方向(默认横向排列 row)*/
	flex-wrap: nowrap;/*容器内项目换行方式*/
	justify-content: center;/*项目在主轴上的对齐方式*/
	align-items: center; /*项目在交叉轴上如何对齐*/
	align-content: center; /*定义了多根轴线的对齐方式。如果项目只有一根轴线，该属性不起作用*/
    
    
}
.boxSize{
    width: 7rem;
    height: 120px;
}
.listSpacing{
    margin-right: 200px;
    float: left;
}


/* 融资 */
.financing{
    background: url('../../assets/img/rongzi.png');
    background-size: 100%;
}

/* 投资 */
.discount{
    background: url("../../assets/img/tiexi.png");
    background-size: 100%;
}



.circle100+p{
    margin-left: 25px;
    margin-bottom: 50px;
}



</style>


// WEBPACK FOOTER //
// src/components/Department_Industry_Finance/FunctionButtons.vue